/* eslint-disable react/no-array-index-key */
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useGetQuotationActionHistory } from "api/queries/shipments/useGetQuotationActionHistory";
import { useGetQuotations } from "api/queries/quotes/useGetQuotations";
import Card from "components/v2/Card/Card";
import usePermissions from "hooks/usePermissions";
import ApprovalTimeline from "./components/ApprovalTimeline/ApprovalTimeline";
import ApprovalUpdateItem from "./components/ApprovalUpdateItem/ApprovalUpdateItem";
import { formatApprovalFlowData } from "../../helpers/approvalFlowHelper";

function ApprovalFlow() {
  const intl = useIntl();
  const { id: paramId } = useParams();
  const id = paramId ? paramId.toUpperCase() : "";
  const { permissions } = usePermissions();
  const { email } = JSON.parse(permissions || "{}");

  const { data: approvalLog } = useGetQuotationActionHistory({
    shipmentId: id,
    options: {
      enabled: !!id,
      select: (data: any) => data.results,
    },
  });

  const { data: quotationData } = useGetQuotations({
    shipmentId: id,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  const formattedApprovalLog = useMemo(
    () => formatApprovalFlowData({ approvalLogs: approvalLog || [], quotationData, currentUserEmail: email }),
    [approvalLog, quotationData, email],
  );

  if (!approvalLog?.length) return null;

  return (
    <div>
      <Card borderRadius="md">
        <Card.Header
          title={intl.formatMessage({
            id: "quote-request.approvalFlow",
            defaultMessage: "Approval flow",
          })}
          showBorder
        />
        <Card.Body>
          {formattedApprovalLog.map((item: any, index: number) => (
            <ApprovalTimeline
              key={index}
              title={item.title}
              date={item.date}
              variant={item.variant}
              showLine={item.showLine}
            >
              {item?.children?.map((child: any, subIndex: number) => (
                <ApprovalUpdateItem
                  key={subIndex}
                  title={child.titleRenderer || child.title}
                  subTitle={child.subTitle}
                  status={child.status}
                  date={child.date}
                  comment={child.comment}
                  showArrow={item.children.length - 1 !== subIndex}
                  action={child.action}
                  additionalData={child.additionalData}
                />
              ))}
            </ApprovalTimeline>
          ))}
        </Card.Body>
      </Card>
    </div>
  );
}

export default ApprovalFlow;
